import { Grid, Modal, Typography } from "@mui/material";
import { GradientButton } from "components/GradientButton";
import React from "react";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import api from "_api";
import CustomTable from "components/TableExplanded/Table";
import useColumns from "./columns/mainColumns";
import useColumnsTwo from "./columns/subColumns";
import useProductData from "./data/data";
import CustomPagination from "components/TableExplanded/Pagination";

const CarProducts = ({ className }) => {
  const [searchTerm, setSearchTerm] = React.useState("");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [isModalOpen, setModalOpen] = React.useState(false);
  const [isViewModalOpen, setViewModalOpen] = React.useState(false);
  const [selectedProduct, setProduct] = React.useState(null);
  const [viewProduct, setViewProduct] = React.useState(null);
  const [filteredRows, setFilteredRows] = React.useState([]);
  const [selectedDateRange, setSelectedDateRange] = React.useState([
    null,
    null,
  ]);
  const [fetchData, setFetchData] = React.useState();

  const handleViewOpen = () => {
    setViewModalOpen(!isViewModalOpen);
    if (viewProduct && isViewModalOpen) setViewProduct(null);
  };
  const fetchProductData = async () => {
    try {
      const { data, isStatus } = await api.product.getOrder();
      // console.log("data", data);
      if (isStatus) setFetchData(data);
    } catch (error) {
      console.error("Error fetching product data:", error);
    }
  };
  React.useEffect(() => {
    fetchProductData();
  }, []);
  const data = useProductData(fetchData);
  const columns = useColumns(
    setViewProduct,
    setProduct,
    handleViewOpen
    // handleModalOpen
  );
  const columnsInside = useColumnsTwo();
  React.useEffect(() => {
    setFilteredRows(data);
  }, [data]);
  // console.log(fetchData)
  return (
    <div className={className}>
      <Grid container spacing={2} style={{ marginBottom: "16px" }}>
        <Grid
          item
          xs={12}
          sm={12}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography component="div" style={{ fontSize: "32px" }}>
            รถทั้งหมด
          </Typography>
          <GradientButton
            //   onClick={handleModalOpen}
            sx={{
              px: 3,
              display: "flex",
              alignItems: "center",
              height: "48px",
            }}
          >
            <Typography style={{ marginRight: "8px" }}>ซื้อสินค้า</Typography>
            <AddCircleIcon fontSize="medium" />
          </GradientButton>
        </Grid>
      </Grid>

      {/* <SearchBar
        searchTerm={searchTerm}
        //   handleSearchChange={handleSearchChange}
        //   handleSearchClick={handleSearchClick}
        //   handleClear={handleClear}
        //   handleDateRangeChange={handleDateRangeChange}
        fieldNames={"buyItems"}
        QRCode={true}
      /> */}

      <CustomTable
        columns={columns}
        columnsInside={columnsInside}
        data={filteredRows?.slice(
          page * rowsPerPage,
          page * rowsPerPage + rowsPerPage
        )}
      />

      <CustomPagination
        count={filteredRows.length}
        page={page}
        rowsPerPage={rowsPerPage}
        //   onPageChange={handlePageChange}
        //   onRowsPerPageChange={handleRowsPerPageChange}
      />
      {/* 
      <Modal
        open={isModalOpen}
        onClose={handleModalOpen}
        selectedProduct={selectedProduct}
        fetchProductData={fetchProductData}
        disableBackdropClick // Prevent clicking outside
        disableEscapeKeyDown // Prevent pressing `Esc`
      /> */}

      {/* <ViewModal
        open={isViewModalOpen}
        onClose={handleViewOpen}
        viewProduct={viewProduct}
      /> */}
    </div>
  );
};
export default CarProducts;
